import { cn } from "~/lib/utils";

/**
 * A static placeholder bar. It does not animate on its own: put
 * `motion-safe:animate-skeleton` on the container that holds the bars, so any number of
 * them costs one stepped opacity animation instead of one per bar.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      aria-hidden
      className={cn("rounded-sm bg-muted", className)}
      data-slot="skeleton"
      {...props}
    />
  );
}

export { Skeleton };
